var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInformationRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45312 2.71094H9.45312V6.46094C9.45312 7.1526 10.0115 7.71094 10.7031 7.71094H14.4531V11.7276H15.7031V6.46094C15.7031 6.29427 15.6365 6.13594 15.5198 6.0276L11.1448 1.6526C11.0365 1.5276 10.8698 1.46094 10.7031 1.46094H4.45312C3.76146 1.46094 3.20312 2.01927 3.20312 2.71094V17.7109C3.20312 18.4026 3.76146 18.9609 4.45312 18.9609H10.9698V17.7109H4.45312V2.71094ZM10.7031 2.96094L14.2031 6.46094H10.7031V2.96094Z",
    fill: "#C10007"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2615 13.0693C13.6365 13.0693 12.3198 14.3859 12.3198 16.0109C12.3198 17.6359 13.6365 18.9526 15.2615 18.9526C16.8865 18.9526 18.2031 17.6359 18.2031 16.0109C18.2031 14.3859 16.8865 13.0693 15.2615 13.0693ZM15.2615 17.9776C14.1781 17.9776 13.3031 17.0943 13.2948 16.0109C13.2948 15.6609 13.3948 15.3193 13.5698 15.0193L16.2448 17.6943C15.9448 17.8776 15.6031 17.9693 15.2531 17.9693L15.2615 17.9776ZM14.2698 14.3359C14.5698 14.1526 14.9115 14.0609 15.2615 14.0609C16.3448 14.0609 17.2198 14.9443 17.2281 16.0276C17.2281 16.3776 17.1281 16.7193 16.9531 17.0193L14.2698 14.3359Z",
    fill: "#C10007"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45312 12.5H5.70312V13.75H9.45312V12.5Z",
    fill: "#C10007"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7031 10H5.70312V11.25H10.7031V10Z",
    fill: "#C10007"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInformationRejected);
export default __webpack_public_path__ + "static/media/ic-information-rejected.4e8c919cd85f3195aee6f1368c3b8bd3.svg";
export { ForwardRef as ReactComponent };